import AdminLayout from "@/views/admin/AdminLayout.vue"
import LanguageSetting from "@/views/admin/settings/LanguageSetting.vue"
import UserManagement from "@/views/admin/settings/UserManagement.vue"
import DataExport from "@/views/admin/settings/DataExport.vue"

const routes = [
  {
    path: "/:lang/settings",
    component: AdminLayout,

    children: [
      {
        path: "",
        redirect: "user-management",
        meta: {
          requireAuth: true,
          auth: 0
        }
      },
      {
        path: "languages",
        name: "Languages",
        component: LanguageSetting,
        meta: {
          title: "Settings.__SiteLanguage",
          requireAuth: true,
          auth: 0
        }
      },
      {
        path: "user-management",
        name: "UserManagement",
        component: UserManagement,
        meta: {
          title: "Settings.__UserManagement",
          requireAuth: true,
          auth: 0
        }
      },
      {
        path: "data-export",
        name: "DataExport",
        component: DataExport,
        meta: {
          title: "Settings.__DataExport",
          requireAuth: true,
          auth: 0
        }
      }
    ]
  }
]

export default routes
